// extracted by mini-css-extract-plugin
export default {"skip-link":"SkipLink_skip-link__R1YbC"};